(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cava-interior"] && !Shopify.designMode) return;
  try {
    
  // Minimal reimplementation of Shopify's `money` filter for client-side
  // updates (mirrors assets/money-formatting.js, which can't be imported
  // from this section's own inline script block — those compile into a
  // plain wrapped function, not an ES module). Assumes a 2-decimal currency,
  // which covers this store's MXN pricing. Shared by the dose configurator
  // and the edition price-block chips below.
  function cavaFormatCents(cents, thousands, decimal, precision) {
    var rounded = (cents / 100).toFixed(precision);
    var parts = rounded.split('.');
    var whole = (parts[0] || '0').replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision <= 0 ? whole : whole + decimal + (parts[1] || '');
  }

  function cavaFormatMoney(cents, format) {
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      var thousands = ',';
      var decimal = '.';
      var precision = 2;
      switch (key) {
        case 'amount_no_decimals':
          precision = 0;
          break;
        case 'amount_with_comma_separator':
          thousands = '.';
          decimal = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousands = '.';
          precision = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousands = ' ';
          precision = 0;
          break;
        case 'amount_with_space_separator':
          thousands = ' ';
          decimal = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousands = ' ';
          decimal = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousands = "'";
          decimal = '.';
          break;
        default:
          break;
      }
      return cavaFormatCents(cents, thousands, decimal, precision);
    });
  }

  var cavaMoneyFormat = document.querySelector('.cava-interior');
  cavaMoneyFormat = (cavaMoneyFormat && cavaMoneyFormat.getAttribute('data-money-format')) || '${{amount}}';

  (function () {
    var root = document.querySelector('[data-cava-configurator]');
    if (!root) return;

    var catalogEl = root.querySelector('[data-cava-dose-catalog]');
    var catalog = [];
    try {
      catalog = JSON.parse(catalogEl.textContent) || [];
    } catch (e) {}
    if (!catalog.length) return;

    var goalGroup = root.querySelector('[data-goal-group]');
    var intensityGroup = root.querySelector('[data-intensity-group]');
    var suggestionText = root.querySelector('[data-suggestion-text]');
    var suggestionPrice = root.querySelector('[data-suggestion-price]');

    // The Reservar button here is a real add-to-cart form (rendered via
    // snippets/cava-reserve-button.liquid), not a link — swapping the goal/
    // intensity just repoints the same form at a different product/variant
    // before it's submitted, so clicking it triggers the theme's normal
    // add-to-cart flow (and the shared cart-drawer's own open/animation,
    // via the cartLinesUpdate event both already listen for).
    var ctaWrap = root.querySelector('[data-suggestion-cta-wrap]');
    var ctaForm = ctaWrap && ctaWrap.querySelector('product-form-component');
    var ctaVariantInput = ctaWrap && ctaWrap.querySelector('input[name="id"]');

    // Goals and intensities are never hardcoded — they're whatever values
    // actually show up on eligible products right now (see the cava_goal
    // metafield loop in this section's Liquid), so adding/removing/
    // relabeling products never requires a code change here. Matching
    // always happens on entry.goal (a stable, untranslated slug); the
    // customer-facing chip text is entry.goalLabel, already resolved to
    // the storefront's current locale in Liquid — this keeps grouping
    // correct regardless of what language the page renders in.
    var goals = [];
    var goalLabels = {};
    catalog.forEach(function (entry) {
      if (goals.indexOf(entry.goal) === -1) {
        goals.push(entry.goal);
        goalLabels[entry.goal] = entry.goalLabel;
      }
    });

    var mgSet = {};
    catalog.forEach(function (entry) {
      entry.variants.forEach(function (v) {
        mgSet[v.mg] = true;
      });
    });
    var mgList = Object.keys(mgSet)
      .map(Number)
      .sort(function (a, b) { return a - b; });

    var state = { goal: goals[0], mg: mgList[0] };

    function findMatch() {
      var candidates = catalog.filter(function (entry) { return entry.goal === state.goal; });
      if (!candidates.length) return null;

      for (var i = 0; i < candidates.length; i++) {
        var exact = candidates[i].variants.filter(function (v) { return v.mg === state.mg; })[0];
        if (exact) return { product: candidates[i], variant: exact };
      }

      // No product at this goal carries the selected mg — fall back to
      // that goal's lowest available dose rather than showing nothing.
      var fallbackProduct = candidates[0];
      var fallbackVariant = fallbackProduct.variants.slice().sort(function (a, b) { return a.mg - b.mg; })[0];
      return fallbackVariant ? { product: fallbackProduct, variant: fallbackVariant } : null;
    }

    function renderChips(container, items, formatLabel, activeValue, onSelect) {
      container.innerHTML = '';
      items.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cava-interior__chip' + (item === activeValue ? ' is-active' : '');
        button.textContent = formatLabel(item);
        button.addEventListener('click', function () {
          onSelect(item);
          update();
        });
        container.appendChild(button);
      });
    }

    function update() {
      renderChips(goalGroup, goals, function (g) { return goalLabels[g] || g; }, state.goal, function (g) { state.goal = g; });
      renderChips(intensityGroup, mgList, function (mg) { return mg + 'mg'; }, state.mg, function (mg) { state.mg = mg; });

      var match = findMatch();
      if (!match) {
        suggestionText.textContent = root.getAttribute('data-no-recommendation') || 'No recommendation available';
        suggestionPrice.textContent = '';
        return;
      }

      suggestionText.textContent = match.product.title + ' · ' + match.variant.mg + 'mg';
      suggestionPrice.textContent = cavaFormatMoney(match.variant.member, cavaMoneyFormat);

      if (ctaForm && ctaVariantInput) {
        ctaVariantInput.value = match.variant.variantId;
        ctaForm.setAttribute('data-product-url', match.product.url);
        ctaForm.setAttribute('data-product-id', match.product.id);
      }
    }

    update();
  })();

  (function () {
    document.querySelectorAll('.cava-interior__edition-card').forEach(function (card) {
      var chips = card.querySelectorAll('[data-edition-dose-chip]');
      if (!chips.length) return;

      var variantsEl = card.querySelector('[data-edition-variants]');
      var variants = {};
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {}

      var publicEl = card.querySelector('[data-edition-price-public]');
      var memberEl = card.querySelector('[data-edition-price-member]');
      var variantInput = card.querySelector('input[name="id"]');

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.disabled) return;

          chips.forEach(function (c) {
            c.classList.toggle('is-active', c === chip);
          });

          var data = variants[chip.getAttribute('data-variant-id')];
          if (!data) return;

          if (publicEl) publicEl.textContent = cavaFormatMoney(data.public, cavaMoneyFormat);
          if (memberEl) memberEl.textContent = cavaFormatMoney(data.member, cavaMoneyFormat);
          if (variantInput) variantInput.value = chip.getAttribute('data-variant-id');
        });
      });
    });
  })();

  (function () {
    document.querySelectorAll('.cava-interior__concierge').forEach(function (form) {
      var openBtn = form.querySelector('[data-concierge-open]');
      var cancelBtn = form.querySelector('[data-concierge-cancel]');
      var panel = form.querySelector('.cava-interior__concierge-panel');
      if (!panel) return;

      if (openBtn) {
        openBtn.addEventListener('click', function () {
          panel.classList.add('is-visible');
          openBtn.hidden = true;
        });
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
          panel.classList.remove('is-visible');
          if (openBtn) openBtn.hidden = false;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cava-request"] && !Shopify.designMode) return;
  try {
    
  // Custom properties (see stylesheet above) handle most color theming,
  // but some pieces have no color-token equivalent: the native title/
  // subtitle text, the custom dropdown's chevron (hardcoded SVG fill),
  // and native radio buttons. Class names below come from inspecting
  // this exact form's rendered shadow DOM — they're app-internal and
  // may change on a future Forms app update; the tag-based rules
  // (label, input, button[type="submit"]) are far more stable.
  (function () {
    var SHADOW_CSS = [
      // Hide the app's own title/subtitle — redundant with our intro text above.
      '[class*="_formHeader_"] { display: none !important; }',

      '[role="dialog"] { background: transparent !important; box-shadow: none !important; padding: 0 !important; }',

      'label, legend, [class*="_label_"] {',
      '  font-family: inherit; font-weight: 300; font-size: 13px !important; color: #CFC8B6 !important;',
      '}',

      'input[type="text"], input[inputmode] {',
      '  background: transparent !important; border: 1px solid rgba(198,162,78,.3) !important;',
      '  border-radius: 0 !important; box-shadow: none !important;',
      // The label floats inside the input box (see its inline "top: 16px"),
      // so top/bottom padding need room for it — a flat 13px on all sides
      // (like the select toggle below) crowds the label against the value.
      '  padding: 30px 14px 10px !important;',
      '  color: #E7E0CF !important; font-size: 14px !important;',
      '}',
      'input[type="text"]::placeholder, input[inputmode]::placeholder { color: rgba(231,224,207,.5) !important; }',

      '[class*="_selectToggle_"] {',
      '  background: transparent !important; border: 1px solid rgba(198,162,78,.3) !important;',
      '  border-radius: 0 !important; padding: 13px 14px !important; width: 100%; text-align: left;',
      '}',
      '[class*="_arrowDownIcon_"] svg path { fill: #C6A24E !important; }',

      'input[type="radio"] {',
      '  appearance: none; width: 16px; height: 16px; border-radius: 50%;',
      '  border: 1px solid #C6A24E !important; background: transparent !important;',
      '  margin: 0; position: relative; flex: none;',
      '}',
      'input[type="radio"]:checked::after {',
      '  content: ""; position: absolute; inset: 3px; border-radius: 50%; background: #C6A24E;',
      '}',
      '[class*="_radioField_"] { display: flex; align-items: center; gap: 8px; }',

      // Nombre/Correo keep their original tight spacing — only the two
      // choice fields (radio grid / select) get extra room above and
      // below, since those were the crowded gaps.
      'form[class*="_formFieldset_"] > [class*="_radioFieldSet_"],',
      'form[class*="_formFieldset_"] > [class*="_selectContainer_"] {',
      '  margin-top: 14px !important; margin-bottom: 22px !important;',
      '}',

      'button[type="submit"] {',
      '  background: linear-gradient(90deg, #C6A24E, #E2C680) !important; color: #20180A !important;',
      '  border: none !important; border-radius: 0 !important; text-transform: uppercase;',
      '  letter-spacing: .18em; font-size: 12px !important; padding: 15px !important;',
      '}',

      '[class*="_formDisclaimer_"] p { color: #9A9280 !important; font-size: 12px !important; }',

      // On mobile the "¿Cómo conociste...?" options render as a cramped
      // multi-column grid, wrapping each label across several lines.
      // Force every choice field (fieldset > options wrapper) to a
      // single column so each option gets full width to breathe.
      '@media screen and (max-width: 480px) {',
      '  fieldset > div {',
      '    display: flex !important; flex-direction: column !important;',
      '    grid-template-columns: none !important; gap: 12px !important;',
      '  }',
      '  fieldset [class*="_radioField_"] { width: 100%; }',
      '}'
    ].join('\n');

    function applyStyles(root) {
      if (!root.querySelector('style[data-cava-request-override]')) {
        var style = document.createElement('style');
        style.setAttribute('data-cava-request-override', 'true');
        style.textContent = SHADOW_CSS;
        root.appendChild(style);
      }
      // The button label ("Solicitar acceso") is form-builder content,
      // not a theme setting — force the requested label here too.
      var submitButton = root.querySelector('button[type="submit"]');
      if (submitButton && submitButton.textContent.trim() !== 'Enviar solicitud') {
        submitButton.textContent = 'Enviar solicitud';
      }
    }

    function tryAttach() {
      var embed = document.getElementById('app-embed');
      if (embed && embed.shadowRoot) {
        applyStyles(embed.shadowRoot);
        // The embed re-renders on validation/loading state changes,
        // which can reset the button label — keep re-applying.
        if (!embed.dataset.cavaRequestObserved) {
          embed.dataset.cavaRequestObserved = 'true';
          new MutationObserver(function () {
            applyStyles(embed.shadowRoot);
          }).observe(embed.shadowRoot, { childList: true, subtree: true });
        }
        return true;
      }
      return false;
    }

    if (!tryAttach()) {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts += 1;
        if (tryAttach() || attempts > 40) {
          clearInterval(interval);
        }
      }, 250);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
